<vc-form-register-email
  *ngIf="(blocToShow | async) == 'email-register'"
  (onUserValidated)="setUser($event)"
  [popinForced]="popinForced"
  [promoOffer]="promoOffer"
></vc-form-register-email>

<vc-form-register-validation
  *ngIf="(blocToShow | async) == 'validation-register'"
  [credentials]="credentials"
  [popinForced]="popinForced"
  [credentialFirstname]="firstname"
></vc-form-register-validation>
